@let images = data.images;

<cac-dialog-layout title="جزئیات دارایی" (onSubmit)="onSubmit($event)">
  <div class="flex flex-wrap gap-x-8 gap-y-4 mt-2 mb-6">
    <app-image-viewer label="" [imageUrl]="images?.at(0)"></app-image-viewer>
    <app-image-viewer label="" [imageUrl]="images?.at(1)"></app-image-viewer>
  </div>
  <cac-form-builder [options]="formBuilder"></cac-form-builder>
  <app-tree-view [control]="locationControl" [fieldMode]="true" label="مکان"></app-tree-view>
</cac-dialog-layout>
